<template>
    <div>
        <!-- Show when Customer Record not exists -->
        <not-found
            v-if="!Object.keys(customerDetails).length && !showPageLoader"
        ></not-found>
        <!-- Show when Customer Record not exists -->

        <!-- When data is loading -->
        <base-table-spinner
            v-if="!Object.keys(customerDetails).length && showPageLoader"
        ></base-table-spinner>
        <!-- When data is loading -->

        <div
            v-if="Object.keys(customerDetails).length"
            class="card customer-info"
        >
            <customer-information
                :show-download-modal="emailProfile ? emailProfile.status : false"
                :customer-details="customerDetails"
            ></customer-information>
        </div>

        <div
            v-if="
                Object.keys(customerDetails).length &&
                customerDetails.kycSummary
            "
            class="filter-section sub-filter"
        >
            <h2>Verification summary</h2>
        </div>
        <div
            v-if="
                Object.keys(customerDetails).length &&
                customerDetails.kycSummary
            "
            class="card customer-info kyc-status-section"
        >
            <div class="row">
                <div
                    v-if="
                        customerDetails.nameScreening == true
                    "
                    class="col-md-12"
                >
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Name Screening</h3>
                        </div>
                        <div class="col-md-4 mb-5">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-sanction"></i
                                    ><label>Sanction</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            black: customerDetails.kycSummary
                                                .nameScreening.sanctionHit,
                                            success:
                                                !customerDetails.kycSummary
                                                    .nameScreening.sanctionHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening
                                                        .sanctionHit,
                                                'icon-check':
                                                    !customerDetails.kycSummary
                                                        .nameScreening
                                                        .sanctionHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-5" v-if="customerDetails.type!='company'">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-tomb"></i><label>PEP</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger: customerDetails.kycSummary
                                                .nameScreening.pepHit,
                                            success:
                                                !customerDetails.kycSummary
                                                    .nameScreening.pepHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening.pepHit,
                                                'icon-check':
                                                    !customerDetails.kycSummary
                                                        .nameScreening.pepHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-5">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-enforcement"></i
                                    ><label>Special Interest</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger: customerDetails.kycSummary
                                                .nameScreening.enforcementHit,
                                            success:
                                                !customerDetails.kycSummary
                                                    .nameScreening
                                                    .enforcementHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening
                                                        .enforcementHit,
                                                'icon-check':
                                                    !customerDetails.kycSummary
                                                        .nameScreening
                                                        .enforcementHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-5">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-world"></i
                                    ><label>Adverse Media</label>
                                </div>
                                <div
                                    v-if="
                                        customerDetails.kycSummary.nameScreening
                                    "
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger: customerDetails.kycSummary
                                                .nameScreening.adverseMediaHit,
                                            success:
                                                !customerDetails.kycSummary
                                                    .nameScreening
                                                    .adverseMediaHit,
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .nameScreening
                                                        .adverseMediaHit,
                                                'icon-check':
                                                    !customerDetails.kycSummary
                                                        .nameScreening
                                                        .adverseMediaHit,
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                </div>

                <!-- ID verification Summary Status -->
                <div v-if="country == 'Pakistan' && customerDetails.type!='company'" class="col-md-4 mb-5">
                    <h3>ID Verification</h3>
                    <div id="idenfoSeal1" class="tags-section">
                        <div class="tags">
                            <i class="icon-blacklist"></i
                            ><label>NADRA Verification</label>
                        </div>
                        <!-- <div v-if="nameScreening == true"> -->
                        <div
                            v-if="
                                customerDetails.customerVerificationStatus.nadra
                            "
                            class="tag-status"
                        >
                            <span
                                :class="{
                                    danger:
                                        customerDetails
                                            .customerVerificationStatus.nadra ==
                                        'notmatched',
                                    success:
                                        customerDetails
                                            .customerVerificationStatus.nadra ==
                                        'matched',
                                    warning:
                                        customerDetails
                                            .customerVerificationStatus.nadra !=
                                            'matched' &&
                                        customerDetails
                                            .customerVerificationStatus.nadra !=
                                            'notmatched',
                                }"
                                ><i
                                    :class="{
                                        'icon-wrong':
                                            customerDetails
                                                .customerVerificationStatus
                                                .nadra == 'notmatched',
                                        'icon-check':
                                            customerDetails
                                                .customerVerificationStatus
                                                .nadra == 'matched',
                                        'icon-hourglass':
                                            customerDetails
                                                .customerVerificationStatus
                                                .nadra != 'matched' &&
                                            customerDetails
                                                .customerVerificationStatus
                                                .nadra != 'notmatched',
                                    }"
                                ></i
                            ></span>
                        </div>
                        <div v-else class="tag-status">
                            <span class="warning">
                                <i class="icon-hourglass"></i>
                            </span>
                        </div>
                    </div>
                    <div
                            v-if="
                                customerDetails.customerVerificationStatus
                                    .idVerificationFile
                            "
                        >
                            <a @click="openPopup2(customerDetails.customerVerificationStatus
                                    .idVerificationFile, 'IDProof')">Preview Document</a>
                    </div>
                </div>

                <!-- Criminal Record Summary Status -->
                <div v-if="country == 'Pakistan' && customerDetails.type!='company'" class="col-md-4 mb-5">
                    <h3>Criminal Record</h3>
                    <div id="idenfoSeal2" class="tags-section">
                        <div class="tags">
                            <i class="icon-blacklist"></i
                            ><label>Criminal Record Verification</label>
                        </div>
                        <!-- <div v-if="nameScreening == true"> -->
                        <div
                            v-if="
                                customerDetails.customerVerificationStatus
                                    .criminalRecordVerification
                            "
                            class="tag-status"
                        >
                            <span
                                :class="{
                                    danger:
                                        customerDetails
                                            .customerVerificationStatus
                                            .criminalRecordVerification ==
                                        'found',
                                    success:
                                        customerDetails
                                            .customerVerificationStatus
                                            .criminalRecordVerification ==
                                        'notfound',
                                    warning:
                                        customerDetails
                                            .customerVerificationStatus
                                            .criminalRecordVerification !=
                                            'found' &&
                                        customerDetails
                                            .customerVerificationStatus
                                            .criminalRecordVerification !=
                                            'notfound',
                                }"
                            >
                                <i
                                    :class="{
                                        'icon-wrong':
                                            customerDetails
                                                .customerVerificationStatus
                                                .criminalRecordVerification ==
                                            'found',
                                        'icon-check':
                                            customerDetails
                                                .customerVerificationStatus
                                                .criminalRecordVerification ==
                                            'notfound',
                                        'icon-hourglass':
                                            customerDetails
                                                .customerVerificationStatus
                                                .criminalRecordVerification !=
                                                'found' &&
                                            customerDetails
                                                .customerVerificationStatus
                                                .criminalRecordVerification !=
                                                'notfound',
                                    }"
                                ></i
                            ></span>
                        </div>
                        <div v-else class="tag-status">
                            <span class="warning">
                                <i class="icon-hourglass"></i>
                            </span>
                        </div>
                    </div>
                    <div
                        v-if="
                            // customerDetails.customerVerificationStatus
                            //     .criminalRecordVerification == 'found' &&
                            customerDetails.customerVerificationStatus
                                .criminalRecordVerificationFile
                        "
                    >
                        <a @click="openPopup">Preview Document</a>
                        <picture-preview-popup
                            :item="criminalRecordDetails"
                        ></picture-preview-popup>
                    </div>
                </div>

                <div
                    v-if="
                        customerDetails.customerVerificationStatus
                            .criminalRecordVerification == 'notfound' &&
                        customerDetails.customerVerificationStatus.nadra ==
                            'matched'
                    "
                >
                    <b-tooltip target="idenfoSeal1" placement="bottom">
                        <template>
                            <img
                                class="resized-image"
                                src="@/assets/images/idenfo-direct-verification-seal.png"
                                alt="Idenfo Verification Seal"
                            />
                        </template>
                    </b-tooltip>
                    <b-tooltip target="idenfoSeal2" placement="bottom">
                        <template>
                            <img
                                class="resized-image"
                                src="@/assets/images/idenfo-direct-verification-seal.png"
                                alt="Idenfo Verification Seal"
                            />
                        </template>
                    </b-tooltip>
                </div>

                <!-- Degree Verification Summary Status -->
                <div
                    v-if="degreeCheck == true && country == 'Pakistan' && customerDetails.type!='company'"
                    class="col-md-4 mb-5"
                >
                    <h3>Degree Verification</h3>
                    <div class="tags-section">
                        <div class="tags">
                            <i class="icon-blacklist"></i
                            ><label>Degree Verification</label>
                        </div>
                        <!-- <div v-if="nameScreening == true"> -->
                        <div
                            v-if="
                                customerDetails.customerVerificationStatus
                                    .degree
                            "
                            class="tag-status"
                        >
                            <span
                                :class="{
                                    danger:
                                        customerDetails
                                            .customerVerificationStatus
                                            .degree == 'notmatched',
                                    success:
                                        customerDetails
                                            .customerVerificationStatus
                                            .degree == 'matched',
                                    warning:
                                        customerDetails
                                            .customerVerificationStatus
                                            .degree != 'matched' &&
                                        customerDetails
                                            .customerVerificationStatus
                                            .degree != 'notmatched',
                                }"
                            >
                                <i
                                    :class="{
                                        'icon-wrong':
                                            customerDetails
                                                .customerVerificationStatus
                                                .degree == 'notmatched',
                                        'icon-check':
                                            customerDetails
                                                .customerVerificationStatus
                                                .degree == 'matched',
                                        'icon-hourglass':
                                            customerDetails
                                                .customerVerificationStatus
                                                .degree != 'matched' &&
                                            customerDetails
                                                .customerVerificationStatus
                                                .degree != 'notmatched',
                                    }"
                                ></i
                            ></span>
                        </div>
                        <div v-else class="tag-status">
                            <span class="warning">
                                <i class="icon-hourglass"></i>
                            </span>
                        </div>
                    </div>
                    <div
                        v-if="
                            // customerDetails.customerVerificationStatus.degree ==
                            //     'matched' &&
                            customerDetails.customerVerificationStatus
                                .degreeVerificationFile
                        "
                    >
                        <a @click="openPopup2(customerDetails.customerVerificationStatus
                                .degreeVerificationFile, 'degreeProof')">Preview Document</a>
                        <!-- <b-modal
                            id="preview2"
                            title="Document Preview"
                            size="md"
                            ok-only
                            ok-title="Close"
                            ok-variant="primary"
                            no-close-on-backdrop
                            no-close-on-esc
                        >
                            <template
                                v-if="
                                    getExt(
                                        customerDetails
                                            .customerVerificationStatus
                                            .degreeVerificationFile
                                    ) == 'pdf'
                                "
                            >
                                <b-btn
                                    slot="modal-footer"
                                    variant="primary"
                                    @click="
                                        onClick(
                                            getFilePath(
                                                customerDetails
                                                    .customerVerificationStatus
                                                    .degreeVerificationFile
                                            ),
                                            'degreeProof'
                                        )
                                    "
                                    >Download</b-btn
                                >
                            </template>
                            <div class="document-preview-section">
                                <div
                                    v-if="
                                        customerDetails &&
                                        customerDetails
                                            .customerVerificationStatus
                                            .degreeVerificationFile
                                    "
                                    class="preview-video"
                                >
                                    <div
                                        v-if="
                                            getExt(
                                                customerDetails
                                                    .customerVerificationStatus
                                                    .degreeVerificationFile
                                            ) == 'pdf'
                                        "
                                        class="preview-video text-center identification-section"
                                    >

                                        <pdf
                                            style="display: block"
                                            :src="
                                                getFilePath(
                                                    customerDetails
                                                        .customerVerificationStatus
                                                        .degreeVerificationFile
                                                )
                                            "
                                            @num-pages="
                                                pageCount = new Array($event)
                                            "
                                        />
                                        <pdf
                                            v-for="(page, index) in pageCount"
                                            :key="index"
                                            :src="
                                                getFilePath(
                                                    customerDetails
                                                        .customerVerificationStatus
                                                        .degreeVerificationFile
                                                )
                                            "
                                            :page="index + 1"
                                        />
                                    </div>
                                    <div v-else>
                                        <img
                                            v-authenticated-image="
                                                'customers/' +
                                                customerDetails
                                                    .customerVerificationStatus
                                                    .degreeVerificationFile
                                            "
                                            class="image-preview"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-modal> -->
                    </div>
                </div>

                <!-- Employment Verification Summary Status -->
                <div
                    v-if="employmentCheck == true && country == 'Pakistan' && customerDetails.type!='company'"
                    class="col-md-4 mb-5"
                >
                    <h3>Employment Verification</h3>
                    <div class="tags-section">
                        <div class="tags">
                            <i class="icon-blacklist"></i
                            ><label>Employment Verification</label>
                        </div>
                        <!-- <div v-if="nameScreening == true"> -->
                        <div
                            v-if="
                                customerDetails.customerVerificationStatus
                                    .employment
                            "
                            class="tag-status"
                        >
                            <span
                                :class="{
                                    danger:
                                        customerDetails
                                            .customerVerificationStatus
                                            .employment == 'notmatched',
                                    success:
                                        customerDetails
                                            .customerVerificationStatus
                                            .employment == 'matched',
                                    warning:
                                        customerDetails
                                            .customerVerificationStatus
                                            .employment != 'matched' &&
                                        customerDetails
                                            .customerVerificationStatus
                                            .employment != 'notmatched',
                                }"
                            >
                                <i
                                    :class="{
                                        'icon-wrong':
                                            customerDetails
                                                .customerVerificationStatus
                                                .employment == 'notmatched',
                                        'icon-check':
                                            customerDetails
                                                .customerVerificationStatus
                                                .employment == 'matched',
                                        'icon-hourglass':
                                            customerDetails
                                                .customerVerificationStatus
                                                .employment != 'matched' &&
                                            customerDetails
                                                .customerVerificationStatus
                                                .employment != 'notmatched',
                                    }"
                                ></i
                            ></span>
                        </div>
                        <div v-else class="tag-status">
                            <span class="warning">
                                <i class="icon-hourglass"></i>
                            </span>
                        </div>
                    </div>
        
                    <div v-if="this.employmentFiles.filter((item)=> item.file).length>0">
                       <a id="popover-open" variant="primary">Click here to see the previews of images</a>

                       <b-popover 
                            target="popover-open" 
                            title="Popover"
                            placement="bottom"
                            :show.sync="popoverShow"
                            >
                            <template #title>
                               <button @click=" onClosePopover" class="close" aria-label="Close">
                                 <span class="d-inline-block" aria-hidden="true">&times;</span>
                               </button>
                               Preview List
                             </template>
                              <div     
                                v-for="(item,index) in this.employmentFiles"
                                v-if=" item.file"
                                >
                                    <p ><a
                                    
                                     @click="openPopup2(item.file)">Preview Document {{ index+1 }}</a></p>
                              </div>
                       </b-popover>
                    </div>    
               
                </div>

                <!-- License verification Summary Status -->
                <div v-if="country == 'Pakistan' && customerDetails.type!='company'" class="col-md-4 mb-5">
                    <h3>License Verification</h3>
                    <div id="idenfoSeal1" class="tags-section">
                        <div class="tags">
                            <i class="icon-blacklist"></i
                            ><label>License Verification</label>
                        </div>
                        <!-- <div v-if="nameScreening == true"> -->
                        <div
                            v-if="
                                customerDetails.customerVerificationStatus.licenseVerification
                            "
                            class="tag-status"
                        >
                            <span
                                :class="{
                                    danger:
                                        customerDetails
                                            .customerVerificationStatus.licenseVerification ==
                                        'notmatched',
                                    success:
                                        customerDetails
                                            .customerVerificationStatus.licenseVerification ==
                                        'matched',
                                    warning:
                                        customerDetails
                                            .customerVerificationStatus.licenseVerification !=
                                            'matched' &&
                                        customerDetails
                                            .customerVerificationStatus.licenseVerification !=
                                            'notmatched',
                                }"
                                ><i
                                    :class="{
                                        'icon-wrong':
                                            customerDetails
                                                .customerVerificationStatus
                                                .licenseVerification == 'notmatched',
                                        'icon-check':
                                            customerDetails
                                                .customerVerificationStatus
                                                .licenseVerification == 'matched',
                                        'icon-hourglass':
                                            customerDetails
                                                .customerVerificationStatus
                                                .licenseVerification != 'matched' &&
                                            customerDetails
                                                .customerVerificationStatus
                                                .licenseVerification != 'notmatched',
                                    }"
                                ></i
                            ></span>
                        </div>
                        <div v-else class="tag-status">
                            <span class="warning">
                                <i class="icon-hourglass"></i>
                            </span>
                        </div>
                    </div>
                    <div
                            v-if="
                                customerDetails.customerVerificationStatus
                                    .licenseVerificationFile
                            "
                        >
                            <a @click="openPopup2(customerDetails.customerVerificationStatus
                                    .licenseVerificationFile, 'LicenseProof')">Preview Document</a>
                    </div>
                </div>
            </div>
            <hr v-if="country=='Pakistan' && customerDetails.type!='company'"/>
            <div class="row">
                <div
                    v-if="
                        customerDetails.liveness == true &&
                        !customerDetails.isSelfServiceRegistration
                    "
                    class="col-md-4"
                >
                    <h3>Documents Verification</h3>
                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-documentation"></i>
                                    <label
                                        v-if="
                                            !customerDetails.kycSummary
                                                .documentationVerification
                                        "
                                        >Document Mismatched</label
                                    >
                                    <label
                                        v-if="
                                            !!customerDetails.kycSummary
                                                .documentationVerification
                                        "
                                        >Document Matched</label
                                    >
                                </div>
                                <div class="tag-status">
                                    <span
                                        :class="{
                                            danger: !customerDetails.kycSummary
                                                .documentationVerification,
                                            success:
                                                !!customerDetails.kycSummary
                                                    .documentationVerification,
                                        }"
                                    >
                                        <i
                                            v-if="
                                                !customerDetails.kycSummary
                                                    .documentationVerification
                                            "
                                            class="icon-wrong"
                                        ></i>
                                        <i
                                            v-if="
                                                !!customerDetails.kycSummary
                                                    .documentationVerification
                                            "
                                            class="icon-check"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="col-md-4" v-if="customerDetails.type!='company'">
                    <h3>Politically Exposed Person (PEP)</h3>
                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-tomb"></i>
                                    <label>Self Declared PEP</label>
                                </div>
                                <div
                                    v-if="customerDetails.isSelfPepHit"
                                    class="tag-status"
                                >
                                    <span
                                        :class="{
                                            danger:
                                                customerDetails.isSelfPepHit == 'high',
                                            success:
                                                customerDetails.isSelfPepHit == 'low',
                                        }"
                                    >
                                        <i
                                            v-if="
                                                customerDetails.isSelfPepHit == 'high'
                                            "
                                            class="icon-wrong"
                                        ></i>
                                        <i
                                            v-if="
                                                customerDetails.isSelfPepHit == 'low'
                                            "
                                            class="icon-check"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="
                        customerDetails.riskFactor == true && riskFactor == true
                    "
                    class="col-md-4"
                >
                    <h3>Risk Rating</h3>

                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-graph"></i
                                    ><label>{{
                                        customerDetails.kycSummary.riskRating
                                            ? customerDetails.kycSummary
                                                  .riskRating
                                            : 'low' | capitalize
                                    }}</label>
                                </div>
                                <div class="tag-status">
                                    <span
                                        :class="{
                                            black:
                                                customerDetails.kycSummary
                                                    .riskRating === 'sanction',
                                            danger:
                                                customerDetails.kycSummary
                                                    .riskRating === 'high',
                                            success:
                                                customerDetails.kycSummary
                                                    .riskRating !==
                                                    'sanction' &&
                                                customerDetails.kycSummary
                                                    .riskRating !== 'high',
                                        }"
                                        ><i
                                            :class="{
                                                'icon-wrong':
                                                    customerDetails.kycSummary
                                                        .riskRating ===
                                                        'sanction' ||
                                                    customerDetails.kycSummary
                                                        .riskRating === 'high',
                                                'icon-check':
                                                    customerDetails.kycSummary
                                                        .riskRating !==
                                                        'sanction' ||
                                                    customerDetails.kycSummary
                                                        .riskRating !== 'high',
                                            }"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="col-md-4" v-if="customerDetails.type!='company' && isDocumentSummary">
                    <h3>Document Upload</h3>
                    <div class="row">
                        <div class="col-md-12 win-small-full">
                            <div class="tags-section">
                                <div class="tags">
                                    <i class="icon-documentation"></i>
                                    <label>Verified</label>
                                </div>
                                <div
        
                                    class="tag-status"
                                >
                                    <span
                                        class="success"
                                    >
                                        <i
                                            class="icon-check"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="customerDetails.lastReview"
            class="filter-section sub-filter"
        >
            <h2>Last Review</h2>
            <div class="card customer-last-review">
                <div class="card-body">
                    <div
                        v-if="
                            customerDetails.lastReview &&
                            !customerDetails.lastReview.reviewBy.profilePicture
                        "
                        class="profile-pic"
                        :style="{
                            'background-image':
                                'url(' +
                                require('@/assets/images/dummy/dummy-user.png') +
                                ')',
                        }"
                    ></div>
                    <div
                        v-if="
                            customerDetails.lastReview &&
                            customerDetails.lastReview.reviewBy.profilePicture
                        "
                        v-authenticated-image="
                            'users/' +
                            customerDetails.lastReview.reviewBy.profilePicture
                        "
                        class="profile-pic"
                    ></div>
                    <div
                        v-if="customerDetails.lastReview"
                        class="details-section"
                    >
                        <h5>
                            {{ customerDetails.lastReview.reviewBy.firstName }}
                            {{ customerDetails.lastReview.reviewBy.lastName }}
                        </h5>
                        <span class="status-types">
                            {{
                                customerDetails.lastReview.reviewBy.roleName
                            }}</span
                        >
                        <span class="status-types">
                            {{
                                customerDetails.lastReview.createdAt
                                    | moment('MMM D, YYYY h:mm a')
                            }}
                        </span>
                        <p
                            class="date-content"
                            v-html="
                                getContent(customerDetails.lastReview.status)
                            "
                        ></p>
                        <p>
                            {{ customerDetails.lastReview.comment }}
                        </p>

                        <div
                            v-if="customerDetails.lastReview.attachment"
                            class="file-section"
                        >
                            <!-- <pdf-icon></pdf-icon> -->
                            <i
                                class="icon-cloud secondary-color icon-download"
                            ></i>
                        </div>
                        <div
                            v-if="numberOfAttachments(customerDetails.lastReview) > 0 "
                            class="file-attach"
                        >
                            <b-button
                                variant="link"
                                @click=" numberOfAttachments(customerDetails.lastReview) == 1  ?
                                    downloadFile(
                                        getFirstAttachment(customerDetails.lastReview)
                                    ) :
                                    downloadAllFiles( customerDetails.lastReview,'Attachments')
                                "
                            >
                                <span class="btn-text"
                                    >Download Attachment</span
                                >
                            </b-button>
                        </div>
                    </div>
                    <base-status
                        :status-type="customerDetails.lastReview.status"
                    ></base-status>
                </div>
            </div>
        </div>
        <b-modal
            id="preview-uploaded-image"
            title="Document Preview"
            size="md"
            ok-only
            ok-title="Close"
            ok-variant="primary"
            no-close-on-backdrop
            no-close-on-esc
            @hide="()=> selectedPreviewItem = ''"
        >
            <template
                v-if="selectedPreviewItem && getExt(selectedPreviewItem) == 'pdf' " >
                <b-btn
                    slot="modal-footer"
                    variant="primary"
                    @click="
                        onClick(
                            getFilePath(
                                selectedPreviewItem
                            ),
                            selectedPreviewItemName
                        )
                    "
                    >Download</b-btn
                >
            </template>
            <div class="document-preview-section">
                <div
                    v-if="selectedPreviewItem"
                    class="preview-video"
                >
                    <div
                        v-if="
                            getExt(
                                selectedPreviewItem
                            ) == 'pdf'
                        "
                        class="preview-video text-center identification-section"
                    >
                        <!-- <pdf :src="pdfSrc" @num-pages="0"></pdf> -->

                        <pdf
                            style="display: block"
                            :src="
                                getFilePath(
                                    selectedPreviewItem
                                )
                            "
                            @num-pages="
                                pageCount = new Array($event)
                            "
                        />
                        <!-- Actual document -->
                        <pdf
                            v-for="(page, index) in pageCount"
                            :key="index"
                            :src="
                                getFilePath(
                                    selectedPreviewItem
                                )
                            "
                            :page="index + 1"
                        />
                    </div>
                    <div v-else>
                        <img
                            v-authenticated-image="
                                'customers/' +
                                selectedPreviewItem
                            "
                            class="image-preview"
                        />
                    </div>
                </div>
            </div>
        </b-modal>
        <cancel-review-process-popup></cancel-review-process-popup>
        <kyc-status-review-popup></kyc-status-review-popup>
        <manual-alert-popup></manual-alert-popup>
        <file-preview-popup
            :customer-details="customerDetails"
        ></file-preview-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import customerInformation from '@/components/CustomerInfo.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'
import kycStatusReviewPopup from '@/components/popups/KYCStatusReviewPopup.vue'
import cancelReviewProcessPopup from '@/components/popups/CancelReviewProcessPopup.vue'
import manualAlertPopup from '@/components/popups/ManualAlertPopup.vue'
import tags from '@/components/Tags.vue'
import NotFound from '@/views/404/NotFound.vue'
import filePreviewPopup from '@/components/popups/FilePreviewPopup.vue'
import picturePreviewPopup from '@/components/popups/PicturePreviewPopup.vue'
import resource from '@/api/resource'
const modulesApi = new resource('configurations/modules')
import request from '@/utils/request'
import pdf from 'vue-pdf'
import axios from 'axios'

import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        customerInformation,
        tags,
        cancelReviewProcessPopup,
        kycStatusReviewPopup,
        pdfIcon,
        manualAlertPopup,
        NotFound,
        filePreviewPopup,
        picturePreviewPopup,
        pdf,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            required: true,
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            popoverShow: false,
            selectedPreviewItem: '',
            selectedPreviewItemName: '',
            APP_URL: process.env.VUE_APP_API_URL,
            country: process.env.VUE_APP_COUNTRY,
            liveness: null,
            nameScreening: null,
            riskFactor: null,
            documentUpload: null,
            companyType: null,
            employmentCheck: null,
            degreeCheck: null,
            emailProfile: {},
            customerDetails: {},
            criminalRecordDetails: {},
            tags: [],
            tagsList: [],
            image: 'member-1.png',
            name: 'Jacqueline Asong',
            subHeading: 'Approver',
            date: 'July 4, 2019 10:45 a.m.',
            // content:
            //     'Submitted KYC Review Status and changed KYC Status to <b>Approved</b> with the following comment,',
            details:
                '"I didn\'t found anything unusual with the profile. All records are clear and up to date."',

            status: [
                {
                    icon: 'icon-check',
                    label: 'Approved',
                    cssClass: 'approved',
                },
            ],
            showPageLoader: true,
        }
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        emailProfile(val){
            //console.log('change of email', val)
        },
        refreshProfile(value) {
            if (value) {
                this.initializeData()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.$router.push({ name: 'view-customer-profile' })
            }
        },
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['refreshProfile', 'dataSegmentId','dataSegmentConfigurations','customerRecord']),
        employmentFiles(){
            let files = this.customerDetails.customerVerificationStatus
            return [{file:files.employmentVerificationFile},{file:files.employmentVerificationFile2},{file:files.employmentVerificationFile3}]
        },
        isDocumentSummary(){
           return (
           (this.customerDetails.identityInfo && this.customerDetails.identityInfo.documentSummary && Object.keys(this.customerDetails.identityInfo.documentSummary).length)
           || (this.customerDetails.identityInfo && this.customerDetails.identityInfo.passport && this.customerDetails.identityInfo.passport.documentSummary && Object.keys(this.customerDetails.identityInfo.passport.documentSummary).length)
          )
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getModuleData(), this.initializeData()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        onClosePopover() {
        this.popoverShow = false
      },
        /**
         *
         * @return {void}
         */
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    // let { data } = await modulesApi.list({
                    //     dataSegmentId: this.dataSegmentId,
                    // })
                    if (!_.isEmpty(this.dataSegmentConfigurations)) {
                        this.liveness = this.dataSegmentConfigurations.liveness
                        this.nameScreening = this.dataSegmentConfigurations.nameScreening
                        this.riskFactor = this.dataSegmentConfigurations.riskFactor
                        this.companyType = this.dataSegmentConfigurations.companyType
                        this.documentUpload = this.dataSegmentConfigurations.documentUpload
                        this.degreeCheck = this.dataSegmentConfigurations.degreeCheck
                        this.emailProfile = this.dataSegmentConfigurations.emailProfile
                        this.employmentCheck = this.dataSegmentConfigurations.employmentCheck
                        // console.log('config data => ',this.emailProfile)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async initializeData() {
            try {
                if (!this.id) {
                    this.id = this.$route.params.id
                }
              if (_.isEmpty(this.customerDetails))
              {
                let { data } = await request({
                  url: `customers/${this.id}`,
                })

                this.customerDetails = data.data
                this.$store.commit('setCustomerRecord', data.data)
              }

                this.criminalRecordDetails.title = 'Found'
                this.criminalRecordDetails.fileName =
                    'customers/' +
                    this.customerDetails.customerVerificationStatus
                        .criminalRecordVerificationFile
                // console.log(this.customerDetails)
                this.$store.commit('setRefreshProfile', false)
            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        }, // End of initializeData() method

        getContent(status) {
            return (
                'Submitted KYC Review Status and changed KYC Status to <b>' +
                _.startCase(status) +
                '</b> with the following comment,'
            )
        }, // End of getContent() method

        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
        }, // End of forceFileDownload() method

        async downloadFile(fileName) {
            let fileUrl = 'customers/' + fileName
            try {
                let response = await request({
                    url: `/files/${fileUrl}`,
                    responseType: 'arraybuffer',
                })
                let fileExtension = response.headers['content-type']
                if (
                    fileExtension == 'image/png' ||
                    fileExtension == 'image/jpg' ||
                    fileExtension == 'image/jpeg'
                ) {
                    this.$bvModal.show('file-preview-popup')
                } else {
                    this.forceFileDownload(response, fileName)
                }
            } catch (err) {
                console.log('Error occured: ', err)
            }
        }, // End of downloadFile() method

        
        async downloadAllFiles(documents,name)
            {
                let filesArray=[]
                let temp={}
                if(documents.attachment)
                {
                    temp={
                        src:'customers/'+documents.attachment,
                        title : documents.attachmentOriginalName
                    }
                    filesArray.push(temp)
                }
                if(documents.attachment2)
                {
                    temp={
                        src:'customers/'+documents.attachment2,
                        title : documents.attachment2OriginalName
                    }
                    filesArray.push(temp)
                }
                if(documents.attachment3)
                {
                    temp={
                        src:'customers/'+documents.attachment3,
                        title : documents.attachment3OriginalName
                    }
                    filesArray.push(temp)
                }
                if(filesArray.length > 0)
                {
                    axios({
                        url: process.env.VUE_APP_FILE_SERVICE_URL + 'download',
                        method: 'POST',
                        data:{files:filesArray},
                        responseType: 'blob', // important
                    }).then((response) => {
                        console.log(response.data.url)
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', name+'_documents.zip'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    }).catch(function(error) {
                        console.log(error);
                    });
                }
                else
                {
                    this.$store.commit('setError', 'No Files found')
                }

            }, // End of downloadAllFiles()

        numberOfAttachments(review){
            let count = 0;
            count += review.attachment ? 1 : 0;
            count += review.attachment2 ? 1 : 0;
            count += review.attachment3 ? 1 : 0;
            return count;
        },
        getFirstAttachment(review){
            let attachment = review.attachment ? review.attachment : 
                            review.attachment2 ? review.attachment2 : 
                            review.attachment3 ? review.attachment3 : '' ;
            return attachment;
        },

        openPopup() {
            console.log('records -----------', this.criminalRecordDetails)
            this.$bvModal.show('picture-preview-popup')
        },
        // openPopup2(id) {
        //     console.log('records -----------', this.criminalRecordDetails)
        //     this.$bvModal.show(id)
        // },
        openPopup2(selectedPreviewItem, selectedPreviewItemName='') {
            console.log('records -----------', this.criminalRecordDetails)
            this.selectedPreviewItem = selectedPreviewItem
            this.selectedPreviewItemName = selectedPreviewItemName
            this.$bvModal.show("preview-uploaded-image")
        },
        getExt(file) {
            return file ? file.split('.').pop() : null
        },
        getFilePath(formData) {
            return (
                process.env.VUE_APP_FILE_SERVICE_URL + 'customers/' + formData
            )
        },
        onClick(url, name) {
            axios({
                url: url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                var fileLink = document.createElement('a')

                fileLink.href = fileURL
                if (this.getExt(url) == 'pdf') {
                    fileLink.setAttribute('download', name?name:'employmentProof' + '.pdf')
                } else if (
                    this.getExt(url) == 'jpg' ||
                    this.getExt(url) == 'png' ||
                    this.getExt(url) == 'jpeg'
                ) {
                    fileLink.setAttribute('download', name + '.png')
                }
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    }, // End of Component > mounted
} // End of export default
</script>
<style>
.resized-image {
    width: 100px;
    height: auto;
}
</style>
